import { l } from 'ui/lib/lodashImports'

export function extractFileFormat(fileName: string): string {
	return l.upperCase(l.last(l.split(fileName, '.')))
}
